import { useEffect } from 'react';
import MessageBar from '../../../message-bar/MessageBar'
import SoundManager, {
  DRAW_PROPOSAL_SOUND,
} from '../../../soundManager/SoundManager'
import styles from "./gameView.module.scss"

const GameMessages = ({
  canAcceptOrRejectDraw,
  isDrawRejected,
  acceptDrawProposal,
  rejectDrawProposal
}) => {

  useEffect(() => {
    if (canAcceptOrRejectDraw) {
      SoundManager.play(DRAW_PROPOSAL_SOUND);
    }

    return () => SoundManager.stopAll()
  }, [canAcceptOrRejectDraw]);

  return (
    <div className={styles.messages}>
      {canAcceptOrRejectDraw && (
        <MessageBar
          className="icon draw-orange"
          title="Draw proposed"
          text="Would you like to accept?"
          buttons={[
            {
              text: 'Accept',
              handler: acceptDrawProposal,
            },
            {
              text: 'Reject',
              handler: rejectDrawProposal,
            },
          ]}
        />
      )}
      {isDrawRejected && (
        <MessageBar
          className="icon draw-orange"
          title="Draw rejected"
          text="Opponent rejected your draw request"
          buttons={[{ text: 'OK' }]}
        />
      )}
    </div>
  );
};

export default GameMessages;
